import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { fleaMarketItemDetailQueryOptions } from "~/features/fleamarket/api";
import { FleaMarketItemDetailTemplate } from "~/features/fleamarket/FleaMarketItemDetailTemplate";

// from=profile: プロフィール経由の表示をトラッキングで区別するための遷移元フラグ
const searchSchema = z.object({
  from: z.enum(["profile"]).optional(),
});

export const Route = createFileRoute("/_authenticated/fleamarket/item/$itemId")(
  {
    validateSearch: searchSchema,
    loader: ({ context: { queryClient }, params: { itemId } }) =>
      queryClient
        .ensureQueryData(fleaMarketItemDetailQueryOptions(itemId))
        .catch(() => undefined),
    component: FleaMarketItemDetailTemplate,
  },
);
